import { getIssueTypeEntitiesMap } from "@adsk/acc-issues-core/state/redux/ducks/issueTypes";
import { useDefaultType } from "./useDefaultType";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { IssueType } from "@adsk/acc-issues-types";

export const useInitialType = (
  overrideTypeId: string | undefined
): IssueType | undefined => {
  const defaultType = useDefaultType();
  const issueEntitiesMap = useSelector(getIssueTypeEntitiesMap);
  const overrideType = overrideTypeId ? issueEntitiesMap[overrideTypeId] : null;
  const initialType = overrideType ?? defaultType;
  return initialType;
};
